export const subscribeEvent = <T extends keyof HTMLElementEventMap>(
  htmlElement: HTMLElement,
  event: T,
  callback: (event: HTMLElementEventMap[T]) => void
) => {
  htmlElement.addEventListener(event, callback);
  return () => htmlElement.removeEventListener(event, callback);
}